import React from 'react';
import SkeletonBlock from '../ui/SkeletonBlock';
import SkeletonRoot from '../ui/SkeletonRoot';
import {
  adminFilterToolbarClass,
  adminListTableShellClass,
  adminListTableSkeletonHeaderClass,
  adminListTableSkeletonRowClass,
} from '../../utils/admin/adminChrome';

/**
 * Branded loading skeleton for Admin Clients Page.
 * Matches dashboard tiles and table layout to prevent layout jump.
 */
const ClientsSkeleton: React.FC = () => {
  return (
    <SkeletonRoot loadingLabel="Loading clients">
      <div className="min-h-screen bg-white">
        <div className="mx-auto max-w-[1400px] px-4 py-8 sm:px-6 lg:px-8">
          <div className="mb-8 border-b border-gray-200 pb-6">
            <SkeletonBlock className="mb-2 h-8 w-64" />
            <SkeletonBlock className="h-5 w-96" />
          </div>

          <div className="mb-8 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="rounded-lg border border-primary-500/10 bg-white p-6">
                <div className="flex items-center">
                  <SkeletonBlock className="mr-4 h-12 w-12 rounded-full" />
                  <div className="flex-1">
                    <SkeletonBlock className="mb-2 h-3 w-20" />
                    <SkeletonBlock className="h-6 w-16" />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mb-8 rounded-lg border border-primary-500/10 bg-white p-6 shadow-xl">
            <div className="mb-6 flex flex-col items-center justify-between gap-4 sm:flex-row">
              <SkeletonBlock className="h-10 w-full rounded sm:w-64" />
              <div className="flex gap-3">
                <SkeletonBlock className="h-10 w-32 rounded" />
                <SkeletonBlock className="h-10 w-40 rounded" />
              </div>
            </div>

            <div className={adminFilterToolbarClass + ' mb-6'}>
              <SkeletonBlock className="h-9 min-w-[200px] flex-1 max-w-sm rounded-lg" />
              <SkeletonBlock className="h-9 w-[180px] rounded-lg" />
            </div>

            <div className="border-t border-gray-100 pt-6">
              <div className={adminListTableShellClass}>
                <div className={adminListTableSkeletonHeaderClass}>
                  <SkeletonBlock className="h-4 w-full" />
                </div>
                {Array.from({ length: 8 }).map((_, i) => (
                  <div key={i} className={adminListTableSkeletonRowClass}>
                    <SkeletonBlock className="h-4 w-40" />
                    <SkeletonBlock className="h-3 w-24" />
                    <SkeletonBlock className="h-4 w-16" />
                    <SkeletonBlock className="h-6 w-20 rounded-full" />
                    <div className="ml-auto flex gap-2">
                      <SkeletonBlock className="h-8 w-16 rounded" />
                      <SkeletonBlock className="h-8 w-16 rounded" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </SkeletonRoot>
  );
};

export default ClientsSkeleton;
